import { useProjectStore } from '@/store/project-store'
import { GalleryItem } from '@/store/gallery/types'

/** Composable containing common background functions */
export default function useBackgroundGalleryItem () {
  const projectStore = useProjectStore()

  const selectBackground = (item: GalleryItem) => {
    let lastItemIndex = item.source.length - 1
    let optimumSizeAsset = item.source[lastItemIndex]
    // We are not interested in any size greater than 1920px
    while (optimumSizeAsset.width && optimumSizeAsset.height && optimumSizeAsset.width >= 1920 && optimumSizeAsset.height >= 1920 && lastItemIndex > 0) {
      optimumSizeAsset = item.source[--lastItemIndex]
    }
    projectStore.setBackground(optimumSizeAsset.src)
  }

  const onDragBackground = (event: DragEvent, background: GalleryItem) => {
    event.dataTransfer?.setData('src', background.source[background.source.length - 1].src)
  }

  const isSelectedBackground = (backgroundItem: GalleryItem) => {
    return backgroundItem.source.some((mediaResource) => projectStore.background.backgroundUrl === mediaResource.src)
  }

  return {
    selectBackground,
    onDragBackground,
    isSelectedBackground
  }
}
